import { IconType } from "@jsq/ds/icons";

// Payment Beneficiary Status Types and Constants
export type PaymentBeneficiaryStatusType =
  | "manual-match"
  | "manual-match-hide-view"
  | "auto-match"
  | "right-match"
  | "pending-update"
  | "add-payment-default"
  | "add-payment-disabled"
  | "not-applicable";

export const DEFAULT_PAYMENT_BENEFICIARY_CONTENT = "Add payment beneficiary";

export interface PaymentBeneficiaryStatusProps {
  status: PaymentBeneficiaryStatusType;
  content?: string | null;
  onEditClick?: () => void;
  onAddClick?: () => void;
}

export interface StatusConfig {
  containerClass: string;
  text: {
    className: string;
    content?: string;
  };
  showViewLink?: boolean;
  showInitialIcon?: boolean;
  initialIconType?: IconType;
  showExternalLink?: boolean;
  initialIconVariant?: "solid" | "outline";
  showPendingText?: boolean;
  showAddIcon?: boolean;
}

export interface InitialIconProps {
  type: IconType;
  variant?: "solid" | "outline";
}

export interface ViewLinkProps {
  showViewLink: boolean;
  onEditClick?: () => void;
}
